import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/elawphant/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/root/elawphant/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/root/elawphant/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\",\"cyrillic\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/root/elawphant/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/root/elawphant/src/shared/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["UtmCapture"] */ "/root/elawphant/src/shared/ui/utm-capture/UtmCapture.tsx");
